module.exports = __webpack_public_path__ + "static/media/social_instush.31cd89b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/social_instush.svg
// module id = 609
// module chunks = 0